import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";

const GetClient = async (bid) => {
  /**
   * input: uid: users id
   * output: user
   * description: fetches user
   */

  try {
    const userDoc = await doc(db, "clients", bid);
    const userDocSnapshot = await getDoc(userDoc);
    const userDocDetails = userDocSnapshot.data();
    return userDocDetails;
  } catch (error) {
    console.log(error);
  }
};

export default GetClient;
